import cn from 'classnames';
import Image from 'next/image';
import { placeholderImageUrl } from '@/lib/constants';

type Props = {
  icon: string;
  name: string;
  desc: string;
  className?: string;
};

export default function ServiceSliderItem({
  icon,
  name,
  desc,
  className,
}: Props) {
  return (
    <article className={cn('bg-white text-center', className)}>
      <div className="flex h-full flex-col items-center justify-start space-y-2">
        <div className="relative h-[120px] w-[120px] shrink-0">
          <Image src={icon || placeholderImageUrl} alt={name} fill />
        </div>

        <h3 className="text-subtitle20 group-hover:text-primary-50 font-semibold text-black">
          {name}
        </h3>
        <p className="min-h-text text-body16 my-2 font-medium text-neutral-50">
          {desc}
        </p>
      </div>
    </article>
  );
}
